const border = {
  radius: {
    none: "0",
    circular: "3rem",
    rounded: "0.25rem",
  },
};

export default border;
